import { FunctionComponent } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { AuthLayout, ErrorPage } from "@/components";
import { ErrorPageType } from "@/enum";
import { useAppSelector } from "@/redux/hooks";
import { PUBLIC_PAGES_AFTER_LOGIN, ROUTE_CONFIG } from "@/routes/config";

import { QuestionnaireLayout } from "@/components/Layouts/QuestionnaireLayout";

import { PrintLayout } from "@/components/Layouts/PrintLayout";

import { AcceptInvitation } from "./pages/AcceptInvitation/AcceptInvitation";
import { ChangePassword } from "./pages/ChangePassword/ChangePassword";
import CheckYourEmail from "./pages/CheckYourEmail/CheckYourEmail";
import { ForgotPassword } from "./pages/ForgotPassword/ForgotPassword";
import { Login } from "./pages/Login/Login";
import { TwoFactorAuth } from "./pages/TwoFactorAuth/TwoFactorAuth";
import { authSelector } from "./redux/auth.slice";
import Questionnaire from "./pages/Questionnaire/Questionnaire";
import ConfirmEmail from "./pages/ConfirmEmail/ConfirmEmail";
import Registration from "./pages/Registration/Registration";
import { Register } from "./pages/Register/Register";
import Home from "./pages/Home/Home";
import Product from "./pages/Product/Product";
import Pricing from "./pages/Pricing/Pricing";
import QuickCheck from "./pages/QuickCheck/QuickCheck";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import { SetPassword } from "./pages/SetPassword/SetPassword";
import Download from "./pages/Download/Download";

const {
	TFA,
	TO_DO_LIST,
	QUESTIONNAIRE,
	LOGIN,
	REGISTRATION,
	REGISTER,
	ACCEPT_INVITATION,
	CHANGE_PASSWORD,
	CHECK_EMAIL,
	CONFIRM_EMAIL,
	FORGOT_PASSWORD,
	ERROR_PAGE,
	SET_PASSWORD,
	DOWNLOAD,
	PRODUCT,
	PRICING,
	QUICK_CHECK,
	ABOUT,
	CONTACT,
	PRIVACY,
} = ROUTE_CONFIG;

export const Public: FunctionComponent = () => {
	const { user, otpToken } = useAppSelector(authSelector);
	const { pathname } = useLocation();

	const publicPages = PUBLIC_PAGES_AFTER_LOGIN.find((pp: string) => pathname.includes(pp));

	if (user && !otpToken && !publicPages && pathname !== ERROR_PAGE) {
		return <Navigate to={TO_DO_LIST} />;
	}

	if (user && otpToken && pathname !== TFA && pathname !== ERROR_PAGE) {
		return <Navigate to={TFA} />;
	}

	return (
		<Routes>
			<Route element={<QuestionnaireLayout />}>
				<Route element={<Home />} path="/" />
				<Route element={<Product />} path={PRODUCT} />
				<Route element={<Pricing />} path={PRICING} />
				<Route element={<QuickCheck />} path={QUICK_CHECK} />
				<Route element={<About />} path={ABOUT} />
				<Route element={<Contact />} path={CONTACT} />
				<Route element={<PrivacyPolicy />} path={PRIVACY} />
				<Route element={<Questionnaire />} path={QUESTIONNAIRE} />
				<Route element={<Registration />} path={REGISTRATION} />
			</Route>
			<Route element={<AuthLayout />}>
				<Route element={<Login />} path={LOGIN} />
				<Route element={<Register />} path={REGISTER} />
				<Route element={<TwoFactorAuth />} path={TFA} />
				<Route element={<AcceptInvitation />} path={ACCEPT_INVITATION} />
				<Route element={<ChangePassword />} path={CHANGE_PASSWORD} />
				<Route element={<ForgotPassword />} path={FORGOT_PASSWORD} />
				<Route element={<CheckYourEmail />} path={CHECK_EMAIL} />
				<Route element={<ConfirmEmail />} path={CONFIRM_EMAIL} />
				<Route element={<SetPassword />} path={SET_PASSWORD} />
			</Route>
			<Route element={<PrintLayout />}>
				<Route element={<Download />} path={DOWNLOAD} />
			</Route>
			<Route element={<ErrorPage type={ErrorPageType.NotFound} />} path="*" />
			<Route element={<ErrorPage type={ErrorPageType.Forbidden} />} path={ERROR_PAGE} />
		</Routes>
	);
};
